module.exports = __webpack_public_path__ + "static/media/instantDeposit.90673856.png";